import { defineStore } from 'pinia';

export const useMortgageStore = defineStore('mortgageStore', {
	// Below sets up https://github.com/prazdevs/pinia-plugin-persistedstate, stored to session base64 encoded 
	persist: {
		storage: sessionStorage,
		serializer: {
			serialize: state => btoa(JSON.stringify(state)),
			deserialize: storeState => JSON.parse(atob(storeState)),
		},
	},
	state: () => ({
		mortgageType: '',
		propertySearchStage: '',
		findingOrCheckingBorrowingAmount: '',
		remortgage: '',
		propertyValue: '',
		deposit: '',
		mortgageDealEnding: '',
		previousMortgageProvider: '',
		borrowingAmount: '',
		increaseBorrowing: '',
	}),
	getters: {
		getAll() {
			return {
				mortgageType: this.mortgageType,
				propertySearchStage: this.propertySearchStage,
				findingOrCheckingBorrowingAmount: this.findingOrCheckingBorrowingAmount,
				remortgage: this.remortgage,
				propertyValue: this.propertyValue,
				deposit: this.deposit,
				mortgageDealEnding: this.mortgageDealEnding,
				previousMortgageProvider: this.previousMortgageProvider,
				borrowingAmount: this.borrowingAmount,
				increaseBorrowing: this.increaseBorrowing,
			}
		}
	},
	actions: {
		postMortgageType(mortgageType) {
			this.mortgageType = mortgageType;
		},
		postPropertySearchStage(stage) {
			this.propertySearchStage = stage;
		},
		postRemortgage(payload) {
			this.remortgage = payload
		},
		postHowWesleyanCanHelp(howToHelp) {
			this.findingOrCheckingBorrowingAmount = howToHelp;
		},
		postPropertyValue(value) {
			this.propertyValue = value;
		},
		postDeposit(deposit) {
			this.deposit = deposit;
		},
		postMortgageDealEnding(mortgageDealEnding) {
			this.mortgageDealEnding = mortgageDealEnding;
		},
		postMortgageProvider(mortgageProvider) {
			this.mortgageProvider = mortgageProvider;
		},
		postBorrowingAmount(payload) {
			this.borrowingAmount = payload;
		},
		postIncreaseBorrowing(payload) {
			this.increaseBorrowing = payload;
		},
	},
});
